module.exports = __webpack_public_path__ + "img/05.ed926bae.png";